import { renderToString } from "react-dom/server";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import React from "react";
import type { TFunction } from "i18next";
import type { Source } from "../../types";
import { pdfStyles } from "./ActionButtons.styles.ts";

export const generatePDFHtml = (content: string, t: TFunction, sources?: Source[]): string => {
  const htmlContent = renderToString(
    React.createElement(ReactMarkdown, { remarkPlugins: [remarkGfm] }, content),
  );

  const now = new Date().toLocaleDateString(t("pdf.locale", "et-EE"), {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${t("pdf.title", "Õigusabi 24 - Vastus")}</title>
        <style>${pdfStyles}</style>
      </head>
      <body>
        <div class="header">
          <div class="brand">
            <p class="logo">${t("common.logo_title", "Õigusabi 24")}</p>
            <span class="tagline">${t("pdf.tagline", "Tehisintellektil põhinev juriidiline assistent")}</span>
          </div>
          <div class="date">${now}</div>
        </div>
        <div class="content">${htmlContent}</div>
        
        ${sources && sources.length > 0
          ? `
          <div class="sources">
            <h2>${t("pdf.sources", "Allikad")}</h2>
            ${sources.map((source, index) => `
              <div class="source-item">
                <a href="${source.url}" class="source-link">[${index + 1}] ${source.title}</a>
                <span class="source-url">${source.url}</span>
              </div>
            `).join("")}
          </div>
        `
          : ""}
        <div class="footer">
          ${t("pdf.generated_by", "Käesolev dokument on genereeritud Õigusabi 24 poolt.")}<br>
          ${t("pdf.disclaimer", "Tähelepanu! Tegemist on informatiivse teabega, mitte juriidilise nõustamisega.")}<br>
          © ${new Date().getFullYear()} ${t("common.logo_title", "Õigusabi 24")}
        </div>
      </body>
    </html>
  `;
};
